export const FORM_SEVERITY_WARNING = 'warning';
export const FORM_SEVERITY_CAUTION = 'caution';
//# sourceMappingURL=formErrors.js.map